import { Component, createRef } from "react";
import { NamirasoftMap } from "namirasoft-site-map";
import { NSARouterMakerResult } from "namirasoft-account-react";
import { NSBox, NSBoxEntity, NSBoxString, NSBoxTextArea, NSColumn } from "namirasoft-site-react";
import { EnvironmentRow, EnvironmentInputRow, ProjectRow } from "namirasoft-infra";
import { InfraLayout } from '../InfraLayout';
import { InfraEntities } from "../InfraEntities";
import { InfraRouterProps } from "../InfraRouterProps";

interface EnvironmentEditPageProps extends NSARouterMakerResult, InfraRouterProps
{
    isEdit: boolean;
}

export default class EnvironmentEditPage extends Component<EnvironmentEditPageProps>
{
    NSBoxString_Name = createRef<NSBoxString>();
    NSBoxEntity_ProjectID = createRef<NSBoxEntity<ProjectRow>>();
    NSBoxTextArea_Description = createRef<NSBoxTextArea>();

    override render()
    {
        let namirasoft = new NamirasoftMap(this.props.account.token_manager, console.error);

        return (
            <InfraLayout<EnvironmentRow, EnvironmentInputRow>
                {...this.props}
                pages={{
                    entity: InfraEntities.environment(this.props),
                    edit: {
                        ...this.props,
                        ui: {
                            tab_page_edit: {
                                editor: {
                                    getInputRow: (): EnvironmentInputRow =>
                                    {
                                        let name = this.NSBoxString_Name.current?.getValue() ?? "";
                                        let project_id = this.NSBoxEntity_ProjectID.current?.getValueOne() ?? "";
                                        let description = this.NSBoxTextArea_Description.current?.getValue() ?? null;

                                        return {
                                            workspace_id: "",
                                            project_id,
                                            name,
                                            description,
                                            environment_category: [],
                                            environment_field: [],
                                            environment_tag: [],
                                        };
                                    },
                                    setRow: (row: EnvironmentRow) =>
                                    {
                                        this.NSBoxString_Name.current?.setValue(row.name);
                                        this.NSBoxEntity_ProjectID.current?.setValueOne(row.project_id);
                                        this.NSBoxTextArea_Description.current?.setValue(row.description);
                                    }
                                }
                            }
                        }
                    }
                }}
            >
                <NSColumn>
                    <NSBoxString
                        ref={this.NSBoxString_Name}
                        required
                        title="Name"
                        style={{ width: NSBox.width.double }}
                    />
                    <NSBoxEntity<ProjectRow>
                        ref={this.NSBoxEntity_ProjectID}
                        title="Project"
                        required
                        multiple={false}
                        table_name="project"
                        table={namirasoft.infra.tables.project}
                        getValue={(item) => item.id}
                        getTitle={(item) => item.name}
                        getSort={() => null}
                        style={{ width: NSBox.width.double }}
                    />
                    <NSBoxTextArea
                        ref={this.NSBoxTextArea_Description}
                        required={false}
                        title="Description"
                        style={{ width: NSBox.width.double }}
                    />
                </NSColumn>
            </InfraLayout>
        );
    }
}